!function (t, n) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : ((t = "undefined" != typeof globalThis ? globalThis : t || self).__SVGATOR_PLAYER__ = t.__SVGATOR_PLAYER__ || {}, t.__SVGATOR_PLAYER__["91c80d77"] = n());
}
(this, (function () {
    "use strict";

    function t(t, n) {
        var e = Object.keys(t);
        if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(t);
            n && (r = r.filter((function (n) {
                return Object.getOwnPropertyDescriptor(t, n).enumerable;
            }))), e.push.apply(e, r);
        }
        return e;
    }

    function n(n) {
        for (var e = 1; e < arguments.length; e++) {
            var r = null != arguments[e] ? arguments[e] : {};
            e % 2 ? t(Object(r), !0).forEach((function (t) {
                o(n, t, r[t]);
            })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(r)) : t(Object(r)).forEach((function (t) {
                Object.defineProperty(n, t, Object.getOwnPropertyDescriptor(r, t));
            }));
        }
        return n;
    }

    function e(t) {
        return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
            return typeof t;
        } : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        })(t);
    }

    function r(t, n) {
        if (!(t instanceof n)) throw new TypeError("Cannot call a class as a function");
    }

    function i(t, n) {
        for (var e = 0; e < n.length; e++) {
            var r = n[e];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
        }
    }

    function u(t, n, e) {
        return n && i(t.prototype, n), e && i(t, e), t;
    }

    function o(t, n, e) {
        return n in t ? Object.defineProperty(t, n, {
            value: e,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : t[n] = e, t;
    }

    function a(t) {
        return (a = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        })(t);
    }

    function l(t, n) {
        return (l = Object.setPrototypeOf || function (t, n) {
            return t.__proto__ = n, t;
        })(t, n);
    }

    function s(t, n) {
        if (n && ("object" == typeof n || "function" == typeof n)) return n;
        if (void 0 !== n) throw new TypeError("Derived constructors may only return object or undefined");
        return function (t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t;
        }(t);
    }

    function f(t) {
        var n = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function () {
                }))), !0;
            } catch (t) {
                return !1;
            }
        }();
        return function () {
            var e, r = a(t);
            if (n) {
                var i = a(this).constructor;
                e = Reflect.construct(r, arguments, i);
            } else e = r.apply(this, arguments);
            return s(this, e);
        };
    }

    function c(t, n, e) {
        return (c = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (t, n, e) {
            var r = function (t, n) {
                for (; !Object.prototype.hasOwnProperty.call(t, n) && null !== (t = a(t));) ;
                return t;
            }(t, n);
            if (r) {
                var i = Object.getOwnPropertyDescriptor(r, n);
                return i.get ? i.get.call(e) : i.value;
            }
        })(t, n, e || t);
    }

    var h = v(Math.pow(10, -6));

    function v(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 6;
        if (Number.isInteger(t)) return t;
        var e = Math.pow(10, n);
        return Math.round((+t + Number.EPSILON) * e) / e;
    }

    function d(t, n) {
        var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h;
        return Math.abs(t - n) < e;
    }

    var y = Math.PI / 180;

    function g(t) {
        return t;
    }

    function p(t, n, e) {
        var r = 1 - e;
        return 3 * e * r * (t * r + n * e) + e * e * e;
    }

    function m() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
            r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
        return t < 0 || t > 1 || e < 0 || e > 1 ? null : d(t, n) && d(e, r) ? g : function (i) {
            if (i <= 0) return t > 0 ? i * n / t : 0 === n && e > 0 ? i * r / e : 0;
            if (i >= 1) return e < 1 ? 1 + (i - 1) * (r - 1) / (e - 1) : 1 === e && t < 1 ? 1 + (i - 1) * (n - 1) / (t - 1) : 1;
            for (var u, o = 0, a = 1; o < a;) {
                var l = p(t, e, u = (o + a) / 2);
                if (d(i, l)) break;
                l < i ? o = u : a = u;
            }
            return p(n, r, u);
        };
    }

    function b() {
        return 1;
    }

    function w(t) {
        return 1 === t ? 1 : 0;
    }

    function x() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
        if (1 === t) {
            if (0 === n) return w;
            if (1 === n) return b;
        }
        var e = 1 / t;
        return function (t) {
            return t >= 1 ? 1 : (t += n * e) - t % e;
        };
    }

    var A = "undefined" != typeof window && /(Mac|iPhone|iPod|iPad)/i.test(window.navigator.platform);
    Object.freeze({
        Meta: A ? "Control" : "Meta",
        Ctrl: "Control",
        Down: "ArrowDown",
        Up: "ArrowUp",
        Left: "ArrowLeft",
        Right: "ArrowRight",
        Esc: "Escape",
        Delete: "Backspace",
        Space: "Space"
    });
    var k = Math.sin, _ = Math.cos, S = Math.acos, O = Math.asin, M = Math.tan, E = Math.atan2,
        P = Math.PI / 180, j = 180 / Math.PI, B = Math.sqrt, I = function () {
            function t() {
                var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                    e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                    i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                    u = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
                    o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                    a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
                r(this, t), this.m = [n, e, i, u, o, a], this.i = null, this.w = null, this.s = null;
            }

            return u(t, [{
                key: "determinant", get: function () {
                    var t = this.m;
                    return t[0] * t[3] - t[1] * t[2];
                }
            }, {
                key: "isIdentity", get: function () {
                    if (null === this.i) {
                        var t = this.m;
                        this.i = 1 === t[0] && 0 === t[1] && 0 === t[2] && 1 === t[3] && 0 === t[4] && 0 === t[5];
                    }
                    return this.i;
                }
            }, {
                key: "point", value: function (t, n) {
                    var e = this.m;
                    return {x: e[0] * t + e[2] * n + e[4], y: e[1] * t + e[3] * n + e[5]};
                }
            }, {
                key: "translateSelf", value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    if (!t && !n) return this;
                    var e = this.m;
                    return e[4] += e[0] * t + e[2] * n, e[5] += e[1] * t + e[3] * n, this.w = this.s = this.i = null, this;
                }
            }, {
                key: "rotateSelf", value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                    if (t %= 360) {
                        var n = k(t *= P), e = _(t), r = this.m, i = r[0], u = r[1];
                        r[0] = i * e + r[2] * n, r[1] = u * e + r[3] * n, r[2] = r[2] * e - i * n, r[3] = r[3] * e - u * n, this.w = this.s = this.i = null;
                    }
                    return this;
                }
            }, {
                key: "scaleSelf", value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                    if (1 !== t || 1 !== n) {
                        var e = this.m;
                        e[0] *= t, e[1] *= t, e[2] *= n, e[3] *= n, this.w = this.s = this.i = null;
                    }
                    return this;
                }
            }, {
                key: "skewSelf", value: function (t, n) {
                    if (n %= 360, (t %= 360) || n) {
                        var e = this.m, r = e[0], i = e[1], u = e[2], o = e[3];
                        t && (t = M(t * P), e[2] += r * t, e[3] += i * t), n && (n = M(n * P), e[0] += u * n, e[1] += o * n), this.w = this.s = this.i = null;
                    }
                    return this;
                }
            }, {
                key: "resetSelf", value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1,
                        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                        e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
                        r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
                        i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0,
                        u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0,
                        o = this.m;
                    return o[0] = t, o[1] = n, o[2] = e, o[3] = r, o[4] = i, o[5] = u, this.w = this.s = this.i = null, this;
                }
            }, {
                key: "recomposeSelf", value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                        e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                        r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
                        i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
                    return this.isIdentity || this.resetSelf(), t && (t.x || t.y) && this.translateSelf(t.x, t.y), n && this.rotateSelf(n), e && (e.x && this.skewSelf(e.x, 0), e.y && this.skewSelf(0, e.y)), !r || 1 === r.x && 1 === r.y || this.scaleSelf(r.x, r.y), i && (i.x || i.y) && this.translateSelf(i.x, i.y), this;
                }
            }, {
                key: "decompose", value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
                        e = this.m, r = e[0] * e[0] + e[1] * e[1], i = [[e[0], e[1]], [e[2], e[3]]],
                        u = B(r);
                    if (0 === u) return {
                        origin: {x: v(e[4]), y: v(e[5])},
                        translate: {x: v(t), y: v(n)},
                        scale: {x: 0, y: 0},
                        skew: {x: 0, y: 0},
                        rotate: 0
                    };
                    i[0][0] /= u, i[0][1] /= u;
                    var o = e[0] * e[3] - e[1] * e[2] < 0;
                    o && (u = -u);
                    var a = i[0][0] * i[1][0] + i[0][1] * i[1][1];
                    i[1][0] -= i[0][0] * a, i[1][1] -= i[0][1] * a;
                    var l = B(i[1][0] * i[1][0] + i[1][1] * i[1][1]);
                    if (0 === l) return {
                        origin: {x: v(e[4]), y: v(e[5])},
                        translate: {x: v(t), y: v(n)},
                        scale: {x: v(u), y: 0},
                        skew: {x: 0, y: 0},
                        rotate: 0
                    };
                    i[1][0] /= l, i[1][1] /= l, a /= l;
                    var s = 0;
                    return i[1][1] < 0 ? (s = S(i[1][1]) * j, i[0][1] < 0 && (s = 360 - s)) : s = O(i[0][1]) * j, o && (s = -s), a = E(a, B(i[0][0] * i[0][0] + i[0][1] * i[0][1])) * j, o && (a = -a), {
                        origin: {
                            x: v(e[4]),
                            y: v(e[5])
                        },
                        translate: {x: v(t), y: v(n)},
                        scale: {x: v(u), y: v(l)},
                        skew: {x: v(a), y: 0},
                        rotate: v(s)
                    };
                }
            }, {
                key: "toString", value: function () {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : " ";
                    return null === this.s && (this.s = "matrix(" + this.m.map((function (t) {
                        return v(t);
                    })).join(t) + ")"), this.s;
                }
            }]), t;
        }();

    function R(t, n, e) {
        return t >= .5 ? e : n;
    }

    function T(t, n, e) {
        return 0 === t || n === e ? n : t * (e - n) + n;
    }

    function N(t, n, e) {
        var r = T(t, n, e);
        return r <= 0 ? 0 : r;
    }

    function C(t, n, e) {
        var r = T(t, n, e);
        return r <= 0 ? 0 : r >= 1 ? 1 : r;
    }

    function L(t, n, e) {
        return 0 === t ? n : 1 === t ? e : {x: T(t, n.x, e.x), y: T(t, n.y, e.y)};
    }

    function F(t, n, e) {
        return 0 === t ? n : 1 === t ? e : {x: N(t, n.x, e.x), y: N(t, n.y, e.y)};
    }

    function q(t, n, e) {
        var r = function (t, n, e) {
            return Math.round(T(t, n, e));
        }(t, n, e);
        return r <= 0 ? 0 : r >= 255 ? 255 : r;
    }

    function V(t, n, e) {
        return 0 === t ? n : 1 === t ? e : {
            r: q(t, n.r, e.r),
            g: q(t, n.g, e.g),
            b: q(t, n.b, e.b),
            a: T(t, null == n.a ? 1 : n.a, null == e.a ? 1 : e.a)
        };
    }

    function D(t, n, e) {
        var r = n.length;
        if (r !== e.length) return R(t, n, e);
        for (var i = new Array(r), u = 0; u < r; u++) i[u] = T(t, n[u], e[u]);
        return i;
    }

    function z(t, n) {
        for (var e = [], r = 0; r < t; r++) e.push(n);
        return e;
    }

    function Y(t, n) {
        if (--n <= 0) return t;
        var e = (t = Object.assign([], t)).length;
        do {
            for (var r = 0; r < e; r++) t.push(t[r]);
        } while (--n > 0);
        return t;
    }

    var G, U = function () {
        function t(n) {
            r(this, t), this.list = n, this.length = n.length;
        }

        return u(t, [{
            key: "setAttribute", value: function (t, n) {
                for (var e = this.list, r = 0; r < this.length; r++) e[r].setAttribute(t, n);
            }
        }, {
            key: "removeAttribute", value: function (t) {
                for (var n = this.list, e = 0; e < this.length; e++) n[e].removeAttribute(t);
            }
        }, {
            key: "style", value: function (t, n) {
                for (var e = this.list, r = 0; r < this.length; r++) e[r].style[t] = n;
            }
        }]), t;
    }(), W = /-./g, $ = function (t, n) {
        return n.toUpperCase();
    };

    function H(t) {
        return "function" == typeof t ? t : R;
    }

    function Q(t) {
        return t ? "function" == typeof t ? t : Array.isArray(t) ? function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : g;
            if (!Array.isArray(t)) return n;
            switch (t.length) {
                case 1:
                    return x(t[0]) || n;
                case 2:
                    return x(t[0], t[1]) || n;
                case 4:
                    return m(t[0], t[1], t[2], t[3]) || n;
            }
            return n;
        }(t, null) : function (t, n) {
            var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : g;
            switch (t) {
                case"linear":
                    return g;
                case"steps":
                    return x(n.steps || 1, n.jump || 0) || e;
                case"bezier":
                case"cubic-bezier":
                    return m(n.x1 || 0, n.y1 || 0, n.x2 || 0, n.y2 || 0) || e;
            }
            return e;
        }(t.type, t.value, null) : null;
    }

    function X(t, n, e) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            i = n.length - 1;
        if (t <= n[0].t) return r ? [0, 0, n[0].v] : n[0].v;
        if (t >= n[i].t) return r ? [i, 1, n[i].v] : n[i].v;
        var u, o = n[0], a = null;
        for (u = 1; u <= i; u++) {
            if (!(t > n[u].t)) {
                a = n[u];
                break;
            }
            o = n[u];
        }
        return null == a ? r ? [i, 1, n[i].v] : n[i].v : o.t === a.t ? r ? [u, 1, a.v] : a.v : (t = (t - o.t) / (a.t - o.t), o.e && (t = o.e(t)), r ? [u, t, e(t, o.v, a.v)] : e(t, o.v, a.v));
    }

    function J(t, n) {
        var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
        return t && t.length ? "function" != typeof n ? null : ("function" != typeof e && (e = null), function (r) {
            var i = X(r, t, n);
            return null != i && e && (i = e(i)), i;
        }) : null;
    }

    function Z(t, n) {
        return t.t - n.t;
    }

    function K(t, n, r, i, u) {
        var o, a = "@" === r[0], l = "#" === r[0], s = G[r], f = R;
        switch (a ? (o = r.substr(1), r = o.replace(W, $)) : l && (r = r.substr(1)), e(s)) {
            case"function":
                if (f = s(i, u, X, Q, r, a, n, t), l) return f;
                break;
            case"string":
                f = J(i, H(s));
                break;
            case"object":
                if ((f = J(i, H(s.i), s.f)) && "function" == typeof s.u) return s.u(n, f, r, a, t);
        }
        return f ? function (t, n, e) {
            if (arguments.length > 3 && void 0 !== arguments[3] && arguments[3]) return t instanceof U ? function (r) {
                return t.style(n, e(r));
            } : function (r) {
                return t.style[n] = e(r);
            };
            if (Array.isArray(n)) {
                var r = n.length;
                return function (i) {
                    var u = e(i);
                    if (null == u) for (var o = 0; o < r; o++) t[o].removeAttribute(n); else for (var a = 0; a < r; a++) t[a].setAttribute(n, u);
                };
            }
            return function (r) {
                var i = e(r);
                null == i ? t.removeAttribute(n) : t.setAttribute(n, i);
            };
        }(n, r, f, a) : null;
    }

    function tt(t, n, r, i) {
        if (!i || "object" !== e(i)) return null;
        var u = null, o = null;
        return Array.isArray(i) ? o = function (t) {
            if (!t || !t.length) return null;
            for (var n = 0; n < t.length; n++) t[n].e && (t[n].e = Q(t[n].e));
            return t.sort(Z);
        }(i) : (o = i.keys, u = i.data || null), o ? K(t, n, r, o, u) : null;
    }

    function nt(t, n, e) {
        if (!e) return null;
        var r = [];
        for (var i in e) if (e.hasOwnProperty(i)) {
            var u = tt(t, n, i, e[i]);
            u && r.push(u);
        }
        return r.length ? r : null;
    }

    function et(t, n) {
        if (!n.duration || n.duration < 0) return null;
        var e = function (t, n) {
            if (!n) return null;
            var e = [];
            if (Array.isArray(n)) for (var r = n.length, i = 0; i < r; i++) {
                var u = n[i];
                if (2 === u.length) {
                    var o = null;
                    if ("string" == typeof u[0]) o = t.getElementById(u[0]); else if (Array.isArray(u[0])) {
                        o = [];
                        for (var a = 0; a < u[0].length; a++) if ("string" == typeof u[0][a]) {
                            var l = t.getElementById(u[0][a]);
                            l && o.push(l);
                        }
                        o = o.length ? 1 === o.length ? o[0] : new U(o) : null;
                    }
                    if (o) {
                        var s = nt(t, o, u[1]);
                        s && (e = e.concat(s));
                    }
                }
            } else for (var f in n) if (n.hasOwnProperty(f)) {
                var c = t.getElementById(f);
                if (c) {
                    var h = nt(t, c, n[f]);
                    h && (e = e.concat(h));
                }
            }
            return e.length ? e : null;
        }(t, n.elements);
        return e ? function (t, n) {
            var e = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1 / 0,
                r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1,
                i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
                u = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1,
                o = t.length, a = r > 0 ? n : 0;
            i && e % 2 == 0 && (a = n - a);
            var l = null;
            return function (s, f) {
                var c = s % n, h = 1 + (s - c) / n;
                f *= r, i && h % 2 == 0 && (f = -f);
                var v = !1;
                if (h > e) c = a, v = !0, -1 === u && (c = r > 0 ? 0 : n); else if (f < 0 && (c = n - c), c === l) return !1;
                l = c;
                for (var d = 0; d < o; d++) t[d](c);
                return v;
            };
        }(e, n.duration, n.iterations || 1 / 0, n.direction || 1, !!n.alternate, n.fill || 1) : null;
    }

    function rt(t) {
        return +("0x" + (t.replace(/[^0-9a-fA-F]+/g, "") || 27));
    }

    function it(t, n, e) {
        return !t || !e || n > t.length ? t : t.substring(0, n) + it(t.substring(n + 1), e, e);
    }

    function ut(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 27;
        return !t || t % n ? t % n : ut(t / n, n);
    }

    function ot(t, n, e) {
        if (t && t.length) {
            var r = rt(e), i = rt(n), u = ut(r) + 5, o = it(t, ut(r, 5), u);
            return o = o.replace(/\x7c$/g, "==").replace(/\x2f$/g, "="), o = function (t, n, e) {
                var r = +("0x" + t.substring(0, 4));
                t = t.substring(4);
                for (var i = n % r + e % 27, u = [], o = 0; o < t.length; o += 2) if ("|" !== t[o]) {
                    var a = +("0x" + t[o] + t[o + 1]) - i;
                    u.push(a);
                } else {
                    var l = +("0x" + t.substring(o + 1, o + 1 + 4)) - i;
                    o += 3, u.push(l);
                }
                return String.fromCharCode.apply(String, u);
            }(o = (o = atob(o)).replace(/[\x41-\x5A]/g, ""), i, r), o = JSON.parse(o);
        }
    }

    Number.isInteger || (Number.isInteger = function (t) {
        return "number" == typeof t && isFinite(t) && Math.floor(t) === t;
    }), Number.EPSILON || (Number.EPSILON = 2220446049250313e-31);
    var at = function () {
        function t(n, e) {
            var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            r(this, t), this._id = 0, this._running = !1, this._rollingBack = !1, this._animations = n, this.duration = e.duration, this.alternate = e.alternate, this.fill = e.fill, this.iterations = e.iterations, this.direction = i.direction || 1, this.speed = i.speed || 1, this.fps = i.fps || 100, this.offset = i.offset || 0, this.rollbackStartOffset = 0;
        }

        return u(t, [{
            key: "_rollback", value: function () {
                var t = this, n = 1 / 0, e = null;
                this.rollbackStartOffset = this.offset, this._rollingBack || (this._rollingBack = !0, this._running = !0);
                this._id = window.requestAnimationFrame((function r(i) {
                    if (t._rollingBack) {
                        null == e && (e = i);
                        var u = i - e, o = t.rollbackStartOffset - u,
                            a = Math.round(o * t.speed);
                        if (a > t.duration && n != 1 / 0) {
                            var l = !!t.alternate && a / t.duration % 2 > 1, s = a % t.duration;
                            a = (s += l ? t.duration : 0) || t.duration;
                        }
                        var f = t.fps ? 1e3 / t.fps : 0, c = Math.max(0, a);
                        if (c < n - f) {
                            t.offset = c, n = c;
                            for (var h = t._animations, v = h.length, d = 0; d < v; d++) h[d](c, t.direction);
                        }
                        var y = !1;
                        if (t.iterations > 0 && -1 === t.fill) {
                            var g = t.iterations * t.duration, p = g == a;
                            a = p ? 0 : a, t.offset = p ? 0 : t.offset, y = a > g;
                        }
                        a > 0 && t.offset >= a && !y ? t._id = window.requestAnimationFrame(r) : t.stop();
                    }
                }));
            }
        }, {
            key: "_start", value: function () {
                var t = this,
                    n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                    e = -1 / 0, r = null, i = {}, u = function u(o) {
                        t._running = !0, null == r && (r = o);
                        var a = Math.round((o - r + n) * t.speed), l = t.fps ? 1e3 / t.fps : 0;
                        if (a > e + l && !t._rollingBack) {
                            t.offset = a, e = a;
                            for (var s = t._animations, f = s.length, c = 0, h = 0; h < f; h++) i[h] ? c++ : (i[h] = s[h](a, t.direction), i[h] && c++);
                            if (c === f) return void t._stop();
                        }
                        t._id = window.requestAnimationFrame(u);
                    };
                this._id = window.requestAnimationFrame(u);
            }
        }, {
            key: "_stop", value: function () {
                this._id && window.cancelAnimationFrame(this._id), this._running = !1, this._rollingBack = !1;
            }
        }, {
            key: "play", value: function () {
                !this._rollingBack && this._running || (this._rollingBack = !1, this.rollbackStartOffset > this.duration && (this.offset = this.rollbackStartOffset - (this.rollbackStartOffset - this.offset) % this.duration, this.rollbackStartOffset = 0), this._start(this.offset));
            }
        }, {
            key: "stop", value: function () {
                this._stop(), this.offset = 0, this.rollbackStartOffset = 0;
                var t = this.direction, n = this._animations;
                window.requestAnimationFrame((function () {
                    for (var e = 0; e < n.length; e++) n[e](0, t);
                }));
            }
        }, {
            key: "reachedToEnd", value: function () {
                return this.iterations > 0 && this.offset >= this.iterations * this.duration;
            }
        }, {
            key: "restart", value: function () {
                this._stop(), this.offset = 0, this._start();
            }
        }, {
            key: "pause", value: function () {
                this._stop();
            }
        }, {
            key: "reverse", value: function () {
                this.direction = -this.direction;
            }
        }], [{
            key: "build", value: function (e, r) {
                return delete e.animationSettings, e.options = ot(e.options, e.root, "91c80d77"), e.animations.map((function (t) {
                    var r = ot(t.s, e.root, "91c80d77");
                    for (var i in delete t.s, e.animationSettings || (e.animationSettings = n({}, r)), r) r.hasOwnProperty(i) && (t[i] = r[i]);
                })), (e = function (t, n) {
                    if (G = n, !t || !t.root || !Array.isArray(t.animations)) return null;
                    for (var e = document.getElementsByTagName("svg"), r = !1, i = 0; i < e.length; i++) if (e[i].id === t.root && !e[i].svgatorAnimation) {
                        (r = e[i]).svgatorAnimation = !0;
                        break;
                    }
                    if (!r) return null;
                    var u = t.animations.map((function (t) {
                        return et(r, t);
                    })).filter((function (t) {
                        return !!t;
                    }));
                    return u.length ? {
                        element: r,
                        animations: u,
                        animationSettings: t.animationSettings,
                        options: t.options || void 0
                    } : null;
                }(e, r)) ? {
                    el: e.element,
                    options: e.options || {},
                    player: new t(e.animations, e.animationSettings, e.options)
                } : null;
            }
        }, {
            key: "push", value: function (t) {
                return this.build(t);
            }
        }, {
            key: "init", value: function () {
                var t = this,
                    n = window.__SVGATOR_PLAYER__ && window.__SVGATOR_PLAYER__["91c80d77"];
                Array.isArray(n) && n.splice(0).forEach((function (n) {
                    return t.build(n);
                }));
            }
        }]), t;
    }();
    !function () {
        for (var t = 0, n = ["ms", "moz", "webkit", "o"], e = 0; e < n.length && !window.requestAnimationFrame; ++e) window.requestAnimationFrame = window[n[e] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[n[e] + "CancelAnimationFrame"] || window[n[e] + "CancelRequestAnimationFrame"];
        window.requestAnimationFrame || (window.requestAnimationFrame = function (n) {
            var e = Date.now(), r = Math.max(0, 16 - (e - t)),
                i = window.setTimeout((function () {
                    n(e + r);
                }), r);
            return t = e + r, i;
        }, window.cancelAnimationFrame = window.clearTimeout);
    }();
    var lt = function (t, n) {
        var e = !1, r = null;
        return function (i) {
            e && clearTimeout(e), e = setTimeout((function () {
                return function () {
                    for (var i = 0, u = window.innerHeight, o = 0, a = window.innerWidth, l = t.parentNode; l instanceof Element;) {
                        var s = window.getComputedStyle(l);
                        if ("visible" !== s.overflowY || "visible" !== s.overflowX) {
                            var f = l.getBoundingClientRect();
                            "visible" !== s.overflowY && (i = Math.max(i, f.top), u = Math.min(u, f.bottom)), "visible" !== s.overflowX && (o = Math.max(o, f.left), a = Math.min(a, f.right));
                        }
                        if (l === l.parentNode) break;
                        l = l.parentNode;
                    }
                    e = !1;
                    var c = t.getBoundingClientRect(),
                        h = Math.min(c.height, Math.max(0, i - c.top)),
                        v = Math.min(c.height, Math.max(0, c.bottom - u)),
                        d = Math.min(c.width, Math.max(0, o - c.left)),
                        y = Math.min(c.width, Math.max(0, c.right - a)),
                        g = (c.height - h - v) / c.height, p = (c.width - d - y) / c.width,
                        m = Math.round(g * p * 100);
                    null !== r && r === m || (r = m, n(m));
                }();
            }), 100);
        };
    }, st = function () {
        function t(n, e, i) {
            r(this, t), e = Math.max(1, e || 1), e = Math.min(e, 100), this.el = n, this.onTresholdChange = i && i.call ? i : function () {
            }, this.tresholdPercent = e || 1, this.currentVisibility = null, this.visibilityCalculator = lt(n, this.onVisibilityUpdate.bind(this)), this.bindScrollWatchers(), this.visibilityCalculator();
        }

        return u(t, [{
            key: "bindScrollWatchers", value: function () {
                for (var t = this.el.parentNode; t && (t.addEventListener("scroll", this.visibilityCalculator), t !== t.parentNode && t !== document);) t = t.parentNode;
            }
        }, {
            key: "onVisibilityUpdate", value: function (t) {
                var n = this.currentVisibility >= this.tresholdPercent,
                    e = t >= this.tresholdPercent;
                if (null === this.currentVisibility || n !== e) return this.currentVisibility = t, void this.onTresholdChange(e);
                this.currentVisibility = t;
            }
        }]), t;
    }();

    function ft(t) {
        return v(t) + "";
    }

    function ct(t) {
        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
        return t && t.length ? t.map(ft).join(n) : "";
    }

    function ht(t) {
        return ft(t.x) + "," + ft(t.y);
    }

    function vt(t) {
        return t ? null == t.a || t.a >= 1 ? "rgb(" + t.r + "," + t.g + "," + t.b + ")" : "rgba(" + t.r + "," + t.g + "," + t.b + "," + t.a + ")" : "transparent";
    }

    function dt(t) {
        return t ? "url(#" + t + ")" : "none";
    }

    var yt = {
        f: null, i: F, u: function (t, n) {
            return function (e) {
                var r = n(e);
                t.setAttribute("rx", ft(r.x)), t.setAttribute("ry", ft(r.y));
            };
        }
    }, gt = {
        f: null, i: function (t, n, e) {
            return 0 === t ? n : 1 === t ? e : {
                width: N(t, n.width, e.width),
                height: N(t, n.height, e.height)
            };
        }, u: function (t, n) {
            return function (e) {
                var r = n(e);
                t.setAttribute("width", ft(r.width)), t.setAttribute("height", ft(r.height));
            };
        }
    };
    Object.freeze({M: 2, L: 2, Z: 0, H: 1, V: 1, C: 6, Q: 4, T: 2, S: 4, A: 7});
    var pt = {}, mt = null;

    function bt(t) {
        var n = function () {
            if (mt) return mt;
            if ("object" !== ("undefined" == typeof document ? "undefined" : e(document)) || !document.createElementNS) return {};
            var t = document.createElementNS("http://www.w3.org/2000/svg", "svg");
            return t && t.style ? (t.style.position = "absolute", t.style.opacity = "0.01", t.style.zIndex = "-9999", t.style.left = "-9999px", t.style.width = "1px", t.style.height = "1px", mt = {svg: t}) : {};
        }().svg;
        if (!n) return function (t) {
            return null;
        };
        var r = document.createElementNS(n.namespaceURI, "path");
        r.setAttributeNS(null, "d", t), r.setAttributeNS(null, "fill", "none"), r.setAttributeNS(null, "stroke", "none"), n.appendChild(r);
        var i = r.getTotalLength();
        return function (t) {
            var n = r.getPointAtLength(i * t);
            return {x: n.x, y: n.y};
        };
    }

    function wt(t) {
        return pt[t] ? pt[t] : pt[t] = bt(t);
    }

    function xt(t, n, e, r) {
        if (!t || !r) return !1;
        var i = ["M", t.x, t.y];
        if (n && e && (i.push("C"), i.push(n.x), i.push(n.y), i.push(e.x), i.push(e.y)), n ? !e : e) {
            var u = n || e;
            i.push("Q"), i.push(u.x), i.push(u.y);
        }
        return n || e || i.push("L"), i.push(r.x), i.push(r.y), i.join(" ");
    }

    function At(t, n, e, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1,
            u = xt(t, n, e, r), o = wt(u);
        try {
            return o(i);
        } catch (t) {
            return null;
        }
    }

    function kt(t, n, e, r) {
        var i = 1 - r;
        return i * i * t + 2 * i * r * n + r * r * e;
    }

    function _t(t, n, e, r) {
        return 2 * (1 - r) * (n - t) + 2 * r * (e - n);
    }

    function St(t, n, e, r) {
        var i = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
            u = At(t, n, null, e, r);
        return u || (u = {
            x: kt(t.x, n.x, e.x, r),
            y: kt(t.y, n.y, e.y, r)
        }), i && (u.a = Ot(t, n, e, r)), u;
    }

    function Ot(t, n, e, r) {
        return Math.atan2(_t(t.y, n.y, e.y, r), _t(t.x, n.x, e.x, r));
    }

    function Mt(t, n, e, r, i) {
        var u = i * i;
        return i * u * (r - t + 3 * (n - e)) + 3 * u * (t + e - 2 * n) + 3 * i * (n - t) + t;
    }

    function Et(t, n, e, r, i) {
        var u = 1 - i;
        return 3 * (u * u * (n - t) + 2 * u * i * (e - n) + i * i * (r - e));
    }

    function Pt(t, n, e, r, i) {
        var u = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
            o = At(t, n, e, r, i);
        return o || (o = {
            x: Mt(t.x, n.x, e.x, r.x, i),
            y: Mt(t.y, n.y, e.y, r.y, i)
        }), u && (o.a = jt(t, n, e, r, i)), o;
    }

    function jt(t, n, e, r, i) {
        return Math.atan2(Et(t.y, n.y, e.y, r.y, i), Et(t.x, n.x, e.x, r.x, i));
    }

    function Bt(t, n, e) {
        return t + (n - t) * e;
    }

    function It(t, n, e) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3],
            i = {x: Bt(t.x, n.x, e), y: Bt(t.y, n.y, e)};
        return r && (i.a = Rt(t, n)), i;
    }

    function Rt(t, n) {
        return Math.atan2(n.y - t.y, n.x - t.x);
    }

    function Tt(t, n, e) {
        var r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
        if (Ct(n)) {
            if (Lt(e)) return St(n, e.start, e, t, r);
        } else if (Ct(e)) {
            if (n.end) return St(n, n.end, e, t, r);
        } else {
            if (n.end) return e.start ? Pt(n, n.end, e.start, e, t, r) : St(n, n.end, e, t, r);
            if (e.start) return St(n, e.start, e, t, r);
        }
        return It(n, e, t, r);
    }

    function Nt(t, n, e) {
        var r = Tt(t, n, e, !0);
        return r.a = function (t) {
            return arguments.length > 1 && void 0 !== arguments[1] && arguments[1] ? t + Math.PI : t;
        }(r.a) / y, r;
    }

    function Ct(t) {
        return !t.type || "corner" === t.type;
    }

    function Lt(t) {
        return null != t.start && !Ct(t);
    }

    var Ft = new I;
    var qt = {
        f: function (t) {
            return t ? t.join(" ") : "";
        }, i: function (t, n, r) {
            if (0 === t) return n;
            if (1 === t) return r;
            var i = n.length;
            if (i !== r.length) return R(t, n, r);
            for (var u, o = new Array(i), a = 0; a < i; a++) {
                if ((u = e(n[a])) !== e(r[a])) return R(t, n, r);
                if ("number" === u) o[a] = T(t, n[a], r[a]); else {
                    if (n[a] !== r[a]) return R(t, n, r);
                    o[a] = n[a];
                }
            }
            return o;
        }
    }, Vt = {
        f: null, i: D, u: function (t, n) {
            return function (e) {
                var r = n(e);
                t.setAttribute("x1", ft(r[0])), t.setAttribute("y1", ft(r[1])), t.setAttribute("x2", ft(r[2])), t.setAttribute("y2", ft(r[3]));
            };
        }
    }, Dt = {f: ft, i: T}, zt = {f: ft, i: C}, Yt = {
        f: function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : " ";
            return t && t.length > 0 && (t = t.map((function (t) {
                return v(t, 4);
            }))), ct(t, n);
        }, i: function (t, n, e) {
            var r, i, u, o = n.length, a = e.length;
            if (o !== a) if (0 === o) n = z(o = a, 0); else if (0 === a) a = o, e = z(o, 0); else {
                var l = (u = (r = o) * (i = a) / function (t, n) {
                    for (var e; n;) e = n, n = t % n, t = e;
                    return t || 1;
                }(r, i)) < 0 ? -u : u;
                n = Y(n, Math.floor(l / o)), e = Y(e, Math.floor(l / a)), o = a = l;
            }
            for (var s = [], f = 0; f < o; f++) s.push(v(N(t, n[f], e[f])));
            return s;
        }
    };

    function Gt(t, n, e) {
        return t.map((function (t) {
            return function (t, n, e) {
                var r = t.v;
                if (!r || "g" !== r.t || r.s || !r.v || !r.r) return t;
                var i = e.getElementById(r.r), u = i && i.querySelectorAll("stop") || [];
                return r.s = r.v.map((function (t, n) {
                    var e = u[n] && u[n].getAttribute("offset");
                    return {c: t, o: e = v(parseInt(e) / 100)};
                })), delete r.v, t;
            }(t, 0, e);
        }));
    }

    var Ut = {
        gt: "gradientTransform",
        c: {x: "cx", y: "cy"},
        rd: "r",
        f: {x: "x1", y: "y1"},
        to: {x: "x2", y: "y2"}
    };

    function Wt(t, n, r, i, u, o, a, l) {
        return Gt(t, 0, l), n = function (t, n, e) {
            for (var r, i, u, o = t.length - 1, a = {}, l = 0; l <= o; l++) (r = t[l]).e && (r.e = n(r.e)), r.v && "g" === (i = r.v).t && i.r && (u = e.getElementById(i.r)) && (a[i.r] = {
                e: u,
                s: u.querySelectorAll("stop")
            });
            return a;
        }(t, i, l), function (i) {
            var u = r(i, t, $t);
            if (!u) return "none";
            if ("c" === u.t) return vt(u.v);
            if ("g" === u.t) {
                if (!n[u.r]) return dt(u.r);
                var o = n[u.r];
                return function (t, n) {
                    for (var e = t.s, r = e.length; r < n.length; r++) {
                        var i = e[e.length - 1].cloneNode();
                        i.id = Xt(i.id), t.e.appendChild(i), e = t.s = t.e.querySelectorAll("stop");
                    }
                    for (var u = 0, o = e.length, a = n.length - 1; u < o; u++) e[u].setAttribute("stop-color", vt(n[Math.min(u, a)].c)), e[u].setAttribute("offset", n[Math.min(u, a)].o);
                }(o, u.s), Object.keys(Ut).forEach((function (t) {
                    if (void 0 !== u[t]) if ("object" !== e(Ut[t])) {
                        var n,
                            r = "gt" === t ? (n = u[t], Array.isArray(n) ? "matrix(" + n.join(" ") + ")" : "") : u[t],
                            i = Ut[t];
                        o.e.setAttribute(i, r);
                    } else Object.keys(Ut[t]).forEach((function (n) {
                        if (void 0 !== u[t][n]) {
                            var e = u[t][n], r = Ut[t][n];
                            o.e.setAttribute(r, e);
                        }
                    }));
                })), dt(u.r);
            }
            return "none";
        };
    }

    function $t(t, e, r) {
        if (0 === t) return e;
        if (1 === t) return r;
        if (e && r) {
            var i = e.t;
            if (i === r.t) switch (e.t) {
                case"c":
                    return {t: i, v: V(t, e.v, r.v)};
                case"g":
                    if (e.r === r.r) {
                        var u = {t: i, s: Ht(t, e.s, r.s), r: e.r};
                        return e.gt && r.gt && (u.gt = D(t, e.gt, r.gt)), e.c ? (u.c = L(t, e.c, r.c), u.rd = N(t, e.rd, r.rd)) : e.f && (u.f = L(t, e.f, r.f), u.to = L(t, e.to, r.to)), u;
                    }
            }
            if ("c" === e.t && "g" === r.t || "c" === r.t && "g" === e.t) {
                var o = "c" === e.t ? e : r, a = "g" === e.t ? n({}, e) : n({}, r),
                    l = a.s.map((function (t) {
                        return {c: o.v, o: t.o};
                    }));
                return a.s = "c" === e.t ? Ht(t, l, a.s) : Ht(t, a.s, l), a;
            }
        }
        return R(t, e, r);
    }

    function Ht(t, n, e) {
        if (n.length === e.length) return n.map((function (n, r) {
            return Qt(t, n, e[r]);
        }));
        for (var r = Math.max(n.length, e.length), i = [], u = 0; u < r; u++) {
            var o = Qt(t, n[Math.min(u, n.length - 1)], e[Math.min(u, e.length - 1)]);
            i.push(o);
        }
        return i;
    }

    function Qt(t, n, e) {
        return {o: C(t, n.o, e.o || 0), c: V(t, n.c, e.c || {})};
    }

    function Xt(t) {
        return t.replace(/-fill-([0-9]+)$/, (function (t, n) {
            return "-fill-" + (+n + 1);
        }));
    }

    var Jt = {
        blur: F, brightness: N, contrast: N, "drop-shadow": function (t, n, e) {
            return 0 === t ? n : 1 === t ? e : {
                blur: F(t, n.blur, e.blur),
                offset: L(t, n.offset, e.offset),
                color: V(t, n.color, e.color)
            };
        }, grayscale: N, "hue-rotate": T, invert: N, opacity: N, saturate: N, sepia: N
    };

    function Zt(t, n, e) {
        if (0 === t) return n;
        if (1 === t) return e;
        var r = n.length;
        if (r !== e.length) return R(t, n, e);
        for (var i, u = [], o = 0; o < r; o++) {
            if (n[o].type !== e[o].type) return n;
            if (!(i = Jt[n[o].type])) return R(t, n, e);
            u.push({type: n.type, value: i(t, n[o].value, e[o].value)});
        }
        return u;
    }

    var Kt = {
        blur: function (t) {
            return t ? function (n) {
                t.setAttribute("stdDeviation", ht(n));
            } : null;
        }, brightness: function (t, n, e) {
            return (t = nn(e, n)) ? function (n) {
                n = ft(n), t.map((function (t) {
                    return t.setAttribute("slope", n);
                }));
            } : null;
        }, contrast: function (t, n, e) {
            return (t = nn(e, n)) ? function (n) {
                var e = ft((1 - n) / 2);
                n = ft(n), t.map((function (t) {
                    t.setAttribute("slope", n), t.setAttribute("intercept", e);
                }));
            } : null;
        }, "drop-shadow": function (t, n, e) {
            var r = e.getElementById(n + "-blur");
            if (!r) return null;
            var i = e.getElementById(n + "-offset");
            if (!i) return null;
            var u = e.getElementById(n + "-flood");
            return u ? function (t) {
                r.setAttribute("stdDeviation", ht(t.blur)), i.setAttribute("dx", ft(t.offset.x)), i.setAttribute("dy", ft(t.offset.y)), u.setAttribute("flood-color", vt(t.color));
            } : null;
        }, grayscale: function (t) {
            return t ? function (n) {
                t.setAttribute("values", ct(function (t) {
                    return [.2126 + .7874 * (t = 1 - t), .7152 - .7152 * t, .0722 - .0722 * t, 0, 0, .2126 - .2126 * t, .7152 + .2848 * t, .0722 - .0722 * t, 0, 0, .2126 - .2126 * t, .7152 - .7152 * t, .0722 + .9278 * t, 0, 0, 0, 0, 0, 1, 0];
                }(n)));
            } : null;
        }, "hue-rotate": function (t) {
            return t ? function (n) {
                return t.setAttribute("values", ft(n));
            } : null;
        }, invert: function (t, n, e) {
            return (t = nn(e, n)) ? function (n) {
                n = ft(n) + " " + ft(1 - n), t.map((function (t) {
                    return t.setAttribute("tableValues", n);
                }));
            } : null;
        }, opacity: function (t, n, e) {
            return (t = e.getElementById(n + "-A")) ? function (n) {
                return t.setAttribute("tableValues", "0 " + ft(n));
            } : null;
        }, saturate: function (t) {
            return t ? function (n) {
                return t.setAttribute("values", ft(n));
            } : null;
        }, sepia: function (t) {
            return t ? function (n) {
                return t.setAttribute("values", ct(function (t) {
                    return [.393 + .607 * (t = 1 - t), .769 - .769 * t, .189 - .189 * t, 0, 0, .349 - .349 * t, .686 + .314 * t, .168 - .168 * t, 0, 0, .272 - .272 * t, .534 - .534 * t, .131 + .869 * t, 0, 0, 0, 0, 0, 1, 0];
                }(n)));
            } : null;
        }
    };
    var tn = ["R", "G", "B"];

    function nn(t, n) {
        var e = tn.map((function (e) {
            return t.getElementById(n + "-" + e) || null;
        }));
        return -1 !== e.indexOf(null) ? null : e;
    }

    var en = {
        fill: Wt,
        "fill-opacity": zt,
        stroke: Wt,
        "stroke-opacity": zt,
        "stroke-width": Dt,
        "stroke-dashoffset": {f: ft, i: T},
        "stroke-dasharray": Yt,
        opacity: zt,
        transform: function (t, n, r, i) {
            if (!(t = function (t, n) {
                if (!t || "object" !== e(t)) return null;
                var r = !1;
                for (var i in t) t.hasOwnProperty(i) && (t[i] && t[i].length ? (t[i].forEach((function (t) {
                    t.e && (t.e = n(t.e));
                })), r = !0) : delete t[i]);
                return r ? t : null;
            }(t, i))) return null;
            var u = function (e, i, u) {
                var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                return t[e] ? r(i, t[e], u) : n && n[e] ? n[e] : o;
            };
            return n && n.a && t.o ? function (n) {
                var e = r(n, t.o, Nt);
                return Ft.recomposeSelf(e, u("r", n, T, 0) + e.a, u("k", n, L), u("s", n, L), u("t", n, L)).toString();
            } : function (t) {
                return Ft.recomposeSelf(u("o", t, Tt, null), u("r", t, T, 0), u("k", t, L), u("s", t, L), u("t", t, L)).toString();
            };
        },
        "#filter": function (t, n, e, r, i, u, o, a) {
            if (!n.items || !t || !t.length) return null;
            var l = function (t, n) {
                var e = (t = t.map((function (t) {
                    return t && Kt[t[0]] ? (n.getElementById(t[1]), Kt[t[0]](n.getElementById(t[1]), t[1], n)) : null;
                }))).length;
                return function (n) {
                    for (var r = 0; r < e; r++) t[r] && t[r](n[r].value);
                };
            }(n.items, a);
            return l ? (t = function (t, n) {
                return t.map((function (t) {
                    return t.e = n(t.e), t;
                }));
            }(t, r), function (n) {
                l(e(n, t, Zt));
            }) : null;
        },
        "#line": Vt,
        points: {f: ct, i: D},
        d: qt,
        r: Dt,
        "#size": gt,
        "#radius": yt,
        _: function (t, n) {
            if (Array.isArray(t)) for (var e = 0; e < t.length; e++) this[t[e]] = n; else this[t] = n;
        }
    }, rn = function (t) {
        !function (t, n) {
            if ("function" != typeof n && null !== n) throw new TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(n && n.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), n && l(t, n);
        }(e, t);
        var n = f(e);

        function e() {
            return r(this, e), n.apply(this, arguments);
        }

        return u(e, null, [{
            key: "build", value: function (t) {
                var n = c(a(e), "build", this).call(this, t, en);
                if (!n) return null;
                var r = n.el, i = n.options, u = n.player;
                return function (t, n, e) {
                    if ("click" === e.start) {
                        var r = function () {
                            switch (e.click) {
                                case"freeze":
                                    return !t._running && t.reachedToEnd() && (t.offset = 0), t._running ? t.pause() : t.play();
                                case"restart":
                                    return t.offset > 0 ? t.restart() : t.play();
                                case"reverse":
                                    var n = !t._rollingBack && t._running, r = t.reachedToEnd();
                                    return n || r && 1 === t.fill ? (t.pause(), r && (t.offset = t.duration - 1), t._rollback()) : r ? t.restart() : t.play();
                                case"none":
                                default:
                                    return !t._running && t.offset ? t.restart() : t.play();
                            }
                        };
                        return void n.addEventListener("click", r);
                    }
                    if ("hover" === e.start) return n.addEventListener("mouseenter", (function () {
                        return t.reachedToEnd() ? t.restart() : t.play();
                    })), void n.addEventListener("mouseleave", (function () {
                        switch (e.hover) {
                            case"freeze":
                                return t.pause();
                            case"reset":
                                return t.stop();
                            case"reverse":
                                return t.pause(), t._rollback();
                            case"none":
                            default:
                                return;
                        }
                    }));
                    if ("scroll" === e.start) return void new st(n, e.scroll || 25, (function (n) {
                        n ? t.reachedToEnd() ? t.restart() : t.play() : t.pause();
                    }));
                    t.play();
                }(u, r, i), u;
            }
        }]), e;
    }(at);
    return rn.init(), rn;
}));
(function (s, i, o, w) {
    w[o] = w[o] || {};
    w[o][s] = w[o][s] || [];
    w[o][s].push(i);
})('91c80d77', {
    "root": "elE83vYi0IL1",
    "animations": [{
        "elements": {
            "elE83vYi0IL2": {
                "transform": {
                    "data": {
                        "o": {
                            "x": 513.700058,
                            "y": 518,
                            "type": "corner"
                        }, "t": {"x": -513.700058, "y": -518}
                    },
                    "keys": {
                        "s": [{
                            "t": 500,
                            "v": {"x": 0.8, "y": 0.8},
                            "e": [0.42, 0, 0.58, 1]
                        }, {"t": 1500, "v": {"x": 1, "y": 1}}]
                    }
                }
            },
            "elE83vYi0IL3": {
                "opacity": [{
                    "t": 500,
                    "v": 0,
                    "e": [0.42, 0, 0.58, 1]
                }, {"t": 1500, "v": 1}]
            },
            "elE83vYi0IL7": {
                "transform": {
                    "data": {"t": {"x": -137.288121, "y": -407.083633}},
                    "keys": {
                        "o": [{
                            "t": 500,
                            "v": {"x": 267.592865, "y": 517.960778, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 1500,
                            "v": {"x": 163.095838, "y": 518.000046, "type": "corner"}
                        }]
                    }
                }, "opacity": [{"t": 500, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 1500, "v": 1}]
            },
            "elE83vYi0IL11": {
                "transform": {
                    "data": {"t": {"x": -765.592254, "y": -418.622865}},
                    "keys": {
                        "o": [{
                            "t": 500,
                            "v": {"x": 708.762234, "y": 517.897948, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 1500,
                            "v": {"x": 812.721042, "y": 517.99999, "type": "corner"}
                        }]
                    }
                }, "opacity": [{"t": 500, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 1500, "v": 1}]
            },
            "elE83vYi0IL15": {
                "transform": {
                    "data": {"t": {"x": -499.082473, "y": -635.179046}},
                    "keys": {
                        "o": [{
                            "t": 900,
                            "v": {"x": 498.520794, "y": 599.930619, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 1800,
                            "v": {"x": 499.082474, "y": 635.179046, "type": "corner"}
                        }],
                        "s": [{
                            "t": 900,
                            "v": {"x": 0.8, "y": 0.8},
                            "e": [0.42, 0, 0.58, 1]
                        }, {"t": 1800, "v": {"x": 1, "y": 1}}]
                    }
                }, "opacity": [{"t": 900, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 1800, "v": 1}]
            },
            "elE83vYi0IL24": {
                "transform": {
                    "data": {"t": {"x": -513.932571, "y": -974.8078}},
                    "keys": {
                        "o": [{
                            "t": 1900,
                            "v": {"x": 513.745571, "y": 954.701159, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 2900,
                            "v": {"x": 513.932572, "y": 974.8078, "type": "corner"}
                        }],
                        "s": [{
                            "t": 1900,
                            "v": {"x": 0.97, "y": 0.97},
                            "e": [0.42, 0, 0.58, 1]
                        }, {"t": 2900, "v": {"x": 1, "y": 1}}]
                    }
                },
                "opacity": [{"t": 1900, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 2900, "v": 1}]
            },
            "elE83vYi0IL37": {
                "transform": {
                    "data": {"t": {"x": -560.511948, "y": -393.879272}},
                    "keys": {
                        "o": [{
                            "t": 900,
                            "v": {"x": 560.511948, "y": 422.824569, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 1800,
                            "v": {"x": 560.511948, "y": 393.879272, "type": "corner"}
                        }],
                        "s": [{
                            "t": 900,
                            "v": {"x": 0.8, "y": 0.8},
                            "e": [0.42, 0, 0.58, 1]
                        }, {"t": 1800, "v": {"x": 1, "y": 1}}]
                    }
                }, "opacity": [{"t": 900, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 1800, "v": 1}]
            },
            "elE83vYi0IL46": {
                "transform": {
                    "data": {"t": {"x": -481.292572, "y": -299.336654}},
                    "keys": {
                        "o": [{
                            "t": 1300,
                            "v": {"x": 481.292568, "y": 323.419022, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 2300,
                            "v": {"x": 481.292572, "y": 299.336655, "type": "corner"}
                        }],
                        "s": [{
                            "t": 1300,
                            "v": {"x": 0.9, "y": 0.9},
                            "e": [0.42, 0, 0.58, 1]
                        }, {"t": 2300, "v": {"x": 1, "y": 1}}]
                    }
                },
                "opacity": [{"t": 1300, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 2300, "v": 1}]
            },
            "elE83vYi0IL59": {
                "transform": {
                    "data": {"t": {"x": -521.209411, "y": -743.863617}},
                    "keys": {
                        "o": [{
                            "t": 1300,
                            "v": {"x": 521, "y": 722.964549, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 2300,
                            "v": {"x": 521.209412, "y": 743.863617, "type": "corner"}
                        }],
                        "s": [{
                            "t": 1300,
                            "v": {"x": 0.9, "y": 0.85},
                            "e": [0.42, 0, 0.58, 1]
                        }, {"t": 2300, "v": {"x": 1, "y": 1}}]
                    }
                },
                "opacity": [{"t": 1300, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 2300, "v": 1}]
            },
            "elE83vYi0IL72": {
                "transform": {
                    "data": {"t": {"x": -477.880798, "y": -167.353416}},
                    "keys": {
                        "o": [{
                            "t": 1600,
                            "v": {"x": 478.034035, "y": 188.687717, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 2600,
                            "v": {"x": 477.880799, "y": 167.353417, "type": "corner"}
                        }],
                        "s": [{
                            "t": 1600,
                            "v": {"x": 0.95, "y": 0.95},
                            "e": [0.42, 0, 0.58, 1]
                        }, {"t": 2600, "v": {"x": 1, "y": 1}}]
                    }
                },
                "opacity": [{"t": 1600, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 2600, "v": 1}]
            },
            "elE83vYi0IL85": {
                "transform": {
                    "data": {"t": {"x": -513.882782, "y": -863.599365}},
                    "keys": {
                        "o": [{
                            "t": 1600,
                            "v": {"x": 513.649014, "y": 842.245887, "type": "corner"},
                            "e": [0.42, 0, 0.58, 1]
                        }, {
                            "t": 2600,
                            "v": {"x": 513.882782, "y": 863.599365, "type": "corner"}
                        }],
                        "s": [{
                            "t": 1600,
                            "v": {"x": 0.95, "y": 0.95},
                            "e": [0.42, 0, 0.58, 1]
                        }, {"t": 2600, "v": {"x": 1, "y": 1}}]
                    }
                },
                "opacity": [{"t": 1600, "v": 0, "e": [0.42, 0, 0.58, 1]}, {"t": 2600, "v": 1}]
            }
        },
        "s": "MDEA1M2IwNTc5OTUFhYWE3OTZhMOTllYTRhM04B1NzZmNjhXNjMU2NTY1NjE1NLzk5OWVhN0k5EYTk4YTk5ZWEB0YTM1NzZmNjCY2MTU3OWVhOXTlhYTc5NmE5AOWVhNGEzYTgA1NzZmNjY2MTLU3OWI5ZWExYHTE1N0I2ZjY2JNjE1Nzk2UWEGxWWE5OWFhN2AEzOTZhOTlhNHTc2ZlhYOWI5NNmExYTg5YTYAxNTdQYThhNTElhOWE5OTU3NKmY2NmIy"
    }],
    "options": "MDVAyMDgyMjk3YNTdiNjg3OTdiGMjk0MTI5NmEN3MzcwNmE3MjKI5MzMyOTZhURTczNzA2YTcyLMjk0MTI5NzUA3Njc1NmMyOTKg0"
}, '__SVGATOR_PLAYER__', window);